import React from 'react';
import {createMuiTheme, makeStyles, MuiThemeProvider} from '@material-ui/core/styles';
import {Box, Button, Divider,  Icon, Paper, TextField, Typography} from '@material-ui/core'
import SyncCloud from './syncCloud.png'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {green} from '@material-ui/core/colors';
import {ApiPostData} from "@project/shared/src/services/ApiPostData";
import {commonValidation} from "@project/shared/src/services/commonValidation";
import PhoneInput from 'react-phone-input-2';
import {nodePostLink} from "@project/shared/src/services/nodePost";
import {toast} from 'react-toastify';
import 'react-phone-input-2/lib/style.css';
import {BaseLink, BaseServerWebsite, BaseURL} from "@project/shared/src/services/postData";
import MaterialUiButtons from "@project/shared/src/components/button/materialUiButton";

const theme = createMuiTheme({
  overrides: {
    MuiOutlinedInput: {
      root: {
        "&$focused $notchedOutline": {
          border: "1px solid #66afe9 !important",
          outline: 'none',
          boxShadow: "inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6) !important"
        },
      },
    },
  },
  typography: {fontFamily: ['"Montserrat", sans-serif'+'!important'].join(','),},
});


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,

    textAlign: 'left',
  },
  saveBtn:{
    background:'#045e06',
    color:'white'
  },
  paper: {
    padding: theme.spacing(4),
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },

  customTextField :props=>({
    "& >label":{
      // background:'white',
    },
    "& .MuiSelect-icon":{
      position:"inherit",
      cursor:"pointer"
    },
    "&>div>fieldset>legend":{
      background:'white'
    },
    "& .MuiIconButton-root:focus":{
      outline:"none"
    },
    "& >div>svg":{
      right:props.iconData!==undefined?
        props.iconData.length===2?62:props.iconData.length===1?41:props.iconData.length===3?84:""
        :"",
    },
  }),

  phoneInput:{
    marginTop: '8px',
    marginBottom: '4px',
    position:'relative',
    "&:hover": {
      "&>div>input": {
        border: '1px solid black',
      },
      "& .flag-dropdown": {
        border: '1px solid black',
      },
    },
    "& .form-control":{
      width:"100%",
      "&:focus":{
        border: "1px solid #66afe9 !important",
        outline: 'none',
        boxShadow: "inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6) !important"
      },
      height: '40px'
    }

  },
  errorStyle:{
    color: 'red',
    float: 'left',
    padding: '0 5px',
    transform: 'translate(-5px, 6px) scale(0.75)',
    background: 'white',
    height: 'max-content',
    marginTop: '-19px',
  },
  phoneTextLabel:{
    zIndex: '10',
    position: 'relative',
    background: 'white',
    padding:  '0 5px',
    left: '40px',
    color: 'rgba(0, 0, 0, 0.54)',
  }
}));
const fields = {
  name: {value: '', valid: false, errorLabel: 'Enter Valid Name', error: ''},
  'company': {value: '', valid: false, errorLabel: 'Enter Valid Company', error: ''},
  email: {value: '', valid: false, errorLabel: 'Enter Valid Email', error: ''},
  phone: {value: '', valid: false, errorLabel: 'Enter Valid Mobile No.', error: ''}
};
const FreeTrial = () => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [freeTrialField, setFreeTrialField] = React.useState({...fields});
  const [formValid, setFormValid] = React.useState(false);

  const handleClickOpen = () => {
    let data = {};
    data['freeTrialParameterArray'] = {};
    for (let key in freeTrialField) {
        data['freeTrialParameterArray'][key] = freeTrialField[key].value;
    }
    data['action'] = 'create';
    ApiPostData('api/websiteApi.php', 'freeTrialRequest', data).then(result => {
      if (result) {
        nodePostLink('/mailer/sendemail/freeTrialClient',data).then((emailClientResult) => {
          if(emailClientResult.status){
            nodePostLink('/mailer/sendemail/freeTrialAdmin',data).then((emailAdminResult) => {
              if(emailAdminResult.status){
                toast.success("Email Sent Succesfully");
                window.location.href=`${BaseLink}${BaseServerWebsite}contactUsThankYou`;
              }else{
                toast.error("Error while sending Email")
              }
            }).catch(function (response) {
            })
          }else{
            toast.error("Error while sending Email")
          }
        }).catch(function (response) {
        })
      } else {
        toast.error('Data is not inserted')
      }
    });

  };

  const handleClose = () => {
    setOpen(false);
    window.location.href=`${BaseURL}`;
  };

  const blurInField = (e, fieldname, validationType) => {
    let updateForm = {...freeTrialField};
    let formValidVar = true;
    let updateFormField = updateForm[fieldname];
    updateFormField.value = e.target.value;


    updateFormField.valid = commonValidation(e.target.value, validationType);

    if (!updateForm[fieldname].valid) {
      updateFormField.error = updateFormField.errorLabel;
    } else {
      updateFormField.error = '';
    }
    updateForm[fieldname] = updateFormField

    for (let key in freeTrialField) {
      formValidVar = updateForm[key].valid && formValidVar;
    }
    setFreeTrialField(updateForm);
    setFormValid(formValidVar)
  }

  const changeInField = (e, fieldname) => {
    let updateForm = {...freeTrialField};

    let updateFormField = updateForm[fieldname];
    updateFormField.value = e.target.value;

    updateForm[fieldname] = updateFormField
    setFreeTrialField(updateForm);
  }

  const changeMobile = (value, ext) => {
    let reqValue = value.replace(ext.dialCode, '');
    reqValue = (reqValue.replace('-', ''));
    reqValue = parseInt(reqValue.replace('+', ''));
    let updateForm = {...freeTrialField};

    let updateFormField = updateForm['phone'];
    updateFormField.value = value;
    if (!isNaN(reqValue) && reqValue !== '') {
      updateFormField.valid = commonValidation(reqValue, {required: true, validationType: 'mobile'});
    } else {
      updateFormField.valid = false;
    }

    let formValidVar = true;
    updateForm['phone'] = updateFormField
    for (let key in updateForm) {
      formValidVar = updateForm[key].valid && formValidVar;
    }
    setFormValid(formValidVar);
    setFreeTrialField(updateForm);
  }

  return (
    <MuiThemeProvider theme={theme}>
      <Box className={classes.root} pt={2} px={3}>
        <img src={SyncCloud} alt='SyncCloud' style={{height: 130}}/>

        <Paper className={classes.paper}>
          <Typography variant="h5" color='textPrimary'>
            Free Trial
          </Typography>

          <form className={classes.form} noValidate autoComplete="off">
            <Box py={2}>
              <TextField
                required
                label='Contact Name'
                variant='outlined'
                size='small'
                fullWidth
                className={classes.customTextField}
                value={freeTrialField['name']['value']}
                onChange={(event) => changeInField(event, 'name',)}
                onBlur={(event) => blurInField(event, 'name', {required: true, validationType: 'alphanumericsplchr'})}
              />
              {!freeTrialField['name'].valid ?
                <div className={classes.errorStyle}>
                    <Typography variant="caption" style={{color: 'red'}}>
                      {freeTrialField['name'].error}
                    </Typography>
                </div>
                :
                <span></span>
              }
            </Box>

            <Box py={2}>
            <TextField
              label='Company'
              variant='outlined'
              size='small'
              required
              fullWidth
              className={classes.customTextField}
              value={freeTrialField['company'].value}
              onChange={(event) => changeInField(event, 'company')}
              onBlur={(event) => blurInField(event, 'company', {required: true, validationType: 'alphanumericsplchr'})}
            />
            {!freeTrialField['company'].valid ?
              <div className={classes.errorStyle}>
                  <Typography variant="caption" style={{color: 'red'}}>
                    {freeTrialField['company'].error}
                  </Typography>
              </div>
              :
              <span></span>
            }
            </Box>

            <Box py={2}>
            <TextField
              label='Business Mail'
              variant='outlined'
              size='small'
              type='email'
              required
              fullWidth
              className={classes.customTextField}
              value={freeTrialField['email'].value}
              onChange={(event) => changeInField(event, 'email')}
              onBlur={(event) => blurInField(event, 'email', {required: true, validationType: 'email'})}
            />
            {!freeTrialField['email'].valid ?
              <div className={classes.errorStyle}>
                  <Typography variant="caption" style={{color: 'red'}}>
                    {freeTrialField['email'].error}
                  </Typography>
              </div>
              :
              <span></span>
            }
            </Box>
            <Box style={{position:'relative'}} pb={2} pt={1}>
              <div className={classes.phoneInput}>
                <PhoneInput
                  name="Phone"
                  country={'in'}
                  value={freeTrialField['phone'].value}
                  onChange={changeMobile}
                  countryCodeEditable={false}
                  enableSearch={true}
                  searchPlaceholder="Search"
                />
                <Box style={{top: '-12px', position: 'absolute'}}>
                  <Typography className={classes.phoneTextLabel} variant="caption">Phone *</Typography>
                </Box>
              </div>
              {!freeTrialField['phone'].valid ?
                <div className={classes.errorStyle}>
                  <Typography variant="caption" style={{color: 'red'}}>
                    {freeTrialField['phone'].error}
                  </Typography>
                </div>
                :
                <span></span>
              }

            </Box>

            <Box textAlign="right">
              <a href={`${BaseURL}`} style={{textDecoration:'none'}}>
                <Box mr={2} display={'inline'}>
                  <MaterialUiButtons
                    iconName="close"
                    color="#f34225"
                    btnTitle="Cancel"
                    btnSize="small"
                  />
                </Box>
              </a>
              <MaterialUiButtons
                iconName="save"
                btnClick={handleClickOpen}
                color="#1b5e20"
                btnTitle="Submit"
                btnDisable={!formValid}
                btnSize="small"
              />
            </Box>


            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                <Box textAlign='center' mt={2}>
                  <Icon style={{fontSize: 50, color: green[500]}}>check_circle</Icon>
                </Box>


              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <Box textAlign='center'>
                    Thanks for choosing syncOffice <br/> Our expert will get in touch with you shortly
                  </Box>
                </DialogContentText>
              </DialogContent>
              <Divider/>
              <DialogActions>

                <Button variant="contained" onClick={handleClose} color="primary" autoFocus>
                  Ok
                </Button>
              </DialogActions>
            </Dialog>


          </form>

        </Paper>

      </Box>
    </MuiThemeProvider>
  );
};

export default FreeTrial;
